import IconBackToTop from "components/EvtKit/icons/IconBackToTop"
import React, { memo, useCallback, useEffect, useState } from "react"
import styled from "styled-components"

const BackToTopButtonContainer = styled.div<{ $isVisible: boolean }>`
  position: sticky;
  bottom: 24px;
  margin-left: auto;
  right: 24px;
  z-index: 1001;
  cursor: pointer;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.25));
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? "visible" : "hidden")};
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
  display: ${({ $isVisible }) => ($isVisible ? "unset" : "none")};

  &:hover {
    opacity: 0.8;
  }
`

interface BackToTopButtonProps {
  scrollContainer?: React.RefObject<HTMLElement>
  threshold?: number
}

const BackToTopButton: React.FC<BackToTopButtonProps> = ({ scrollContainer, threshold = 100 }) => {
  const [showBackToTop, setShowBackToTop] = useState(false)

  const scrollToTop = useCallback(() => {
    const container = scrollContainer?.current

    if (container) {
      container.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  }, [scrollContainer])

  const handleScroll = useCallback(() => {
    const container = scrollContainer?.current

    if (container) {
      const scrollTop = container.scrollTop

      setShowBackToTop(scrollTop > threshold)
    }
  }, [scrollContainer, threshold])

  useEffect(() => {
    const container = scrollContainer?.current

    if (container) {
      container.addEventListener("scroll", handleScroll, { passive: true })

      return () => {
        container.removeEventListener("scroll", handleScroll)
      }
    }
  }, [handleScroll, scrollContainer])

  return (
    <BackToTopButtonContainer $isVisible={showBackToTop} onClick={scrollToTop}>
      <IconBackToTop />
    </BackToTopButtonContainer>
  )
}

export default memo(BackToTopButton)
